module.exports = __webpack_public_path__ + "static/leah-fd9ee517adcaede4a481fb3ce31fe08a.png";